import { base64Encode } from '@cred/react-analytics/utils/data'

const generateBase64String = (params) => base64Encode(JSON.stringify(params))

export const getMetaQuery = (params, theme) => {
  const base64EncodedString = generateBase64String(params)
  const isFox = ['fox', 'fox1'].includes(theme)

  // Only return the generated Base64 encoded string for Fox theme
  return isFox ? `&meta=${base64EncodedString}` : ''
}

export const removeEmptyValues = (obj) => {
  return Object.keys(obj).reduce((acc, key) => {
    return obj[key] ? { ...acc, [key]: obj[key] } : { ...acc }
  }, {})
}
